import _ from "lodash";
import IndividualProfile from "marketplace/individuals/profiles/individual-profile";

export default class UpdateMarketplaceIndividualProfileAPIRequest {
  payload: { op: string; path: string; value: unknown }[] | null = null;

  constructor(isVisible?: boolean, originalProfile?: IndividualProfile, updatedProfile?: IndividualProfile) {
    this.payload = [];

    if (isVisible !== undefined) {
      this.payload.push({
        op: "replace",
        path: "/isVisible",
        value: isVisible,
      });
    }

    if (!originalProfile || !updatedProfile) {
      return;
    }
    // Simple value comparisons
    this.compareAndPush(updatedProfile, originalProfile, "firstName");
    this.compareAndPush(updatedProfile, originalProfile, "lastName");
    this.compareAndPush(updatedProfile, originalProfile, "professionalRegistration");
    this.compareAndPush(updatedProfile, originalProfile, "description");
    this.compareAndPush(updatedProfile, originalProfile, "isOnCall");
    this.compareAndPush(updatedProfile, originalProfile, "school");
    this.compareAndPush(updatedProfile, originalProfile, "degree");
    this.compareAndPush(updatedProfile, originalProfile, "numberOfAllowedApplications");
    this.compareAndPush(updatedProfile, originalProfile, "barAdmissionYear");
    this.compareAndPush(updatedProfile, originalProfile, "potentialDiversityCandidate");
    this.compareAndPush(updatedProfile, originalProfile, "collaborates");

    // Deep equality comparisons
    this.deepCompareAndPush(updatedProfile, originalProfile, "phoneNumber");
    this.deepCompareAndPush(updatedProfile, originalProfile, "location");
    this.deepCompareAndPush(updatedProfile, originalProfile, "categories");
    this.deepCompareAndPush(updatedProfile, originalProfile, "regionsRegistered");
    this.deepCompareAndPush(updatedProfile, originalProfile, "fluentLanguages");
    this.deepCompareAndPush(updatedProfile, originalProfile, "technicalLanguages");
    this.deepCompareAndPush(updatedProfile, originalProfile, "regionsLicensed");
    this.deepCompareAndPush(updatedProfile, originalProfile, "sampleApplications");
    this.deepCompareAndPush(updatedProfile, originalProfile, "professionalPublications");
    this.deepCompareAndPush(updatedProfile, originalProfile, "links");

    // Special cases
    if (!updatedProfile.email?.isEqualTo(originalProfile.email)) {
      this.payload.push({
        op: "replace",
        path: "/email",
        value: updatedProfile.email?.value ?? "",
      });
    }

    if (
      updatedProfile.numberOfApplicationsDraftedProsecuted !== originalProfile.numberOfApplicationsDraftedProsecuted
    ) {
      this.payload.push({
        op: "replace",
        path: "/numberOfApplicationsDraftedProsecuted",
        value: updatedProfile.numberOfApplicationsDraftedProsecuted,
      });
    }

    if (updatedProfile.technicalBackground !== originalProfile.technicalBackground) {
      this.payload.push({
        op: "replace",
        path: "/technicalBackground",
        value: updatedProfile.technicalBackground?.value,
      });
    }

    if (updatedProfile.insured?.insuredAmount !== originalProfile.insured?.insuredAmount) {
      this.payload.push({
        op: "replace",
        path: "/insuredAmount",
        value: updatedProfile.insured?.insuredAmount,
      });
    }

    if (updatedProfile.billingRate?.billingRate !== originalProfile.billingRate?.billingRate) {
      this.payload.push({
        op: "replace",
        path: "/billingRate",
        value: updatedProfile.billingRate?.billingRate,
      });
    }

    if (updatedProfile.billingRate?.billingUnit !== originalProfile.billingRate?.billingUnit) {
      this.payload.push({
        op: "replace",
        path: "/billingUnit",
        value: updatedProfile.billingRate?.billingUnit,
      });
    }
  }

  private compareAndPush(
    updatedProfile: IndividualProfile,
    originalProfile: IndividualProfile,
    key: keyof IndividualProfile,
  ) {
    if (updatedProfile[key] !== originalProfile[key]) {
      this.payload?.push({
        op: "replace",
        path: `/${key}`,
        value: updatedProfile[key],
      });
    }
  }

  private deepCompareAndPush(
    updatedProfile: IndividualProfile,
    originalProfile: IndividualProfile,
    key: keyof IndividualProfile,
  ) {
    if (!_.isEqual(updatedProfile[key], originalProfile[key])) {
      this.payload?.push({
        op: "replace",
        path: `/${key}`,
        value: updatedProfile[key],
      });
    }
  }
}
